<!-- Hero Section -->
<section id="hero">
  <app-crm-hero></app-crm-hero>
</section>

<!-- At a Glance Section -->
<section id="glance">
  <app-crm-glance></app-crm-glance>
</section>

<!-- Sales Pipeline Section -->
<section id="pipeline">
  <app-crm-pipeline></app-crm-pipeline>
</section>

<!-- Activities / Marketing / Services Section -->
<section id="workflow">
  <app-crm-workflow></app-crm-workflow>
</section>

<!-- Mobile Section -->
<section id="mobile">
  <app-crm-mobile></app-crm-mobile>
</section>

<!-- CTA Section -->
<section id="cta">
  <app-crm-cta></app-crm-cta>
</section>
